import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Per-page SEO meta tag component.
 * Sets title (max 60 chars), description (max 160 chars), canonical,
 * robots, Open Graph and Twitter Card tags.
 *
 * Usage on any page: <SEOHead title="..." description="..." path="/pricing" />
 */
const SITE_URL = 'https://imocode.app';
const DEFAULT_IMAGE = `${SITE_URL}/logo-imocode.png`;

const SEOHead = ({
  title,
  description,
  path = '/',
  image = DEFAULT_IMAGE,
  noindex = false,
  type = 'website'
}) => {
  const fullTitle = title && title.length > 60 ? title.slice(0, 57) + '...' : (title || 'IMOCODE');
  const fullDesc = description && description.length > 160 ? description.slice(0, 157) + '...' : description;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {fullDesc && <meta name="description" content={fullDesc} />}
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="IMOCODE" />
      <meta property="og:title" content={fullTitle} />
      {fullDesc && <meta property="og:description" content={fullDesc} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="pt_PT" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {fullDesc && <meta name="twitter:description" content={fullDesc} />}
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEOHead;
